import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";

import HomeDashboard from './pages/home-dashboard';
import OnboardingAuthentication from './pages/onboarding-authentication';
import PortfolioTracker from './pages/portfolio-tracker';
import WinMarketplaceProducts from './pages/win-marketplace-products';
import InvestmentOpportunities from './pages/investment-opportunities';
import CommunityHub from './pages/community-hub';
import MemberProfiles from './pages/member-profiles';
import MemberProfileDetail from './pages/member-profiles/MemberProfileDetail';
import PublicLandingPage from './pages/public-landing-page';
import BusinessApplicationModal from './pages/business-application-modal';
import AdminApplicationReviewDashboard from './pages/admin-application-review-dashboard';
import ErrorPage404 from './pages/404-error-page';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<PublicLandingPage />} />
        <Route path="/public-landing-page" element={<PublicLandingPage />} />
        <Route path="/home-dashboard" element={<HomeDashboard />} />
        <Route path="/onboarding-authentication" element={<OnboardingAuthentication />} />
        <Route path="/portfolio-tracker" element={<PortfolioTracker />} />
        <Route path="/win-marketplace-products" element={<WinMarketplaceProducts />} />
        <Route path="/investment-opportunities" element={<InvestmentOpportunities />} />
        <Route path="/community-hub" element={<CommunityHub />} />
        <Route path="/members" element={<MemberProfiles />} />
        <Route path="/members/:id" element={<MemberProfileDetail />} />
        <Route path="/business-application-modal" element={<BusinessApplicationModal />} />
        <Route path="/admin-application-review-dashboard" element={<AdminApplicationReviewDashboard />} />
        <Route path="/profile" element={<Navigate to="/onboarding-authentication" replace />} />
        <Route path="/404-error-page" element={<ErrorPage404 />} />
        <Route path="*" element={<ErrorPage404 />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
